module.exports = __webpack_public_path__ + "img/portfolio3.ca633c12.jpg";